export const FAMILY_GAMES = [
  {
    id: 'sketch-guess',
    name: 'Sketch & Guess',
    emoji: '🎨',
    tagline: 'Draw it, guess it, laugh about it',
    shortDesc: 'One person draws, everyone guesses',
    description: 'Just like Pictionary! One person gets a secret word or phrase and draws it. Everyone else tries to guess what it is. No words, no letters, just shapes and creativity.',
    howToPlay: [
      'Tap "Start Game" and pick how many rounds',
      'The drawer gets a secret prompt (only they can see it)',
      'Draw it on the canvas — no letters or numbers allowed!',
      'Share it to the circle and see if anyone can guess',
      'Take turns being the drawer each round',
    ],
    tip: "Don't worry about being a good artist — the funniest drawings are the ones that look nothing like the prompt. You can also ask Ross to help you draw!",
    minPlayers: 2,
    hasRounds: true,
    defaultRounds: 3,
    category: 'guessing',
  },
  {
    id: 'art-relay',
    name: 'Art Relay',
    emoji: '🏓',
    tagline: 'Take turns, build something together',
    shortDesc: 'Each person adds to the same artwork',
    description: 'The classic Art Ping Pong! One person starts a drawing, then passes it to the next person who adds to it. Keep going around the circle until your masterpiece is complete.',
    howToPlay: [
      'Pick how many rounds (times around the circle)',
      'First person draws anything to start',
      'Next person draws on top of what\'s there — add, change, remix',
      'Keep going around until all rounds are done',
      'Admire your collaborative creation!',
    ],
    tip: "There are no mistakes here — every addition makes it more interesting. Want help? Ask Ross to suggest what to add next.",
    minPlayers: 2,
    hasRounds: true,
    defaultRounds: 2,
    category: 'collaborative',
  },
  {
    id: 'scene-builder',
    name: 'Scene Builder',
    emoji: '🏗️',
    tagline: 'Everyone adds something to the scene',
    shortDesc: 'Build a world together, piece by piece',
    description: 'Someone picks a setting (beach, space, kitchen, jungle), then each person adds something to it. A person, an animal, a UFO — anything goes. Build a scene that tells a story.',
    howToPlay: [
      'First person draws the background setting (beach, city, forest, etc.)',
      'Each person adds one thing: a character, object, animal, or detail',
      'Keep adding until the scene feels complete',
      'Name your creation together!',
    ],
    prompts: [
      'A day at the beach',
      'An alien planet',
      'The wildest kitchen ever',
      'A magical forest',
      'Under the ocean',
      'A city in the clouds',
      'The craziest playground',
      'A haunted house (funny, not scary!)',
      'Grandma\'s backyard',
      'A spaceship interior',
    ],
    tip: "The more random the additions, the better the story. Someone drew a beach? Add a dinosaur surfing. Tell Ross what you want to add and he can help you draw it.",
    minPlayers: 2,
    hasRounds: false,
    category: 'collaborative',
  },
  {
    id: 'dream-vacation',
    name: 'Dream Vacation',
    emoji: '✈️',
    tagline: 'Where should we go? Draw it!',
    shortDesc: 'Everyone draws their dream trip',
    description: 'Each person draws something from their dream family vacation — where they want to go, what they want to do, what they want to eat, who they want to meet. Compare at the end and plan your next adventure!',
    howToPlay: [
      'Everyone draws their own dream vacation scene',
      'Include: the place, an activity, a food, and a surprise',
      'Share your drawings to the circle',
      'Compare and vote on where to go!',
    ],
    tip: "This is a great conversation starter. You might discover your 7-year-old really wants to visit Japan, or grandpa dreams of seeing the Northern Lights. Ask Ross to help bring your vision to life!",
    minPlayers: 2,
    hasRounds: false,
    category: 'creative',
  },
  {
    id: 'monster-mash',
    name: 'Monster Mash',
    emoji: '👾',
    tagline: 'Everyone builds one monster together',
    shortDesc: 'Head, body, legs, details — one at a time',
    description: 'Build a creature together! First person draws the head, next draws the body, next adds legs or arms, and the last person adds accessories, colors, and details. The result is always hilarious.',
    howToPlay: [
      'Round 1: Draw the head (face, eyes, horns, whatever!)',
      'Round 2: Add the body (big, small, slimy, fluffy)',
      'Round 3: Add legs, arms, tentacles, or wheels',
      'Round 4: Accessories, colors, and final details',
      'Name your monster and give it a backstory!',
    ],
    tip: "The less you plan, the funnier it gets. A princess head on a robot body with octopus legs? Chef's kiss. Ross can help you draw any part — just describe what you're imagining.",
    minPlayers: 2,
    hasRounds: true,
    defaultRounds: 4,
    fixedRounds: true,
    category: 'collaborative',
  },
  {
    id: 'emoji-challenge',
    name: 'Emoji Art',
    emoji: '😎',
    tagline: 'Turn emojis into drawings',
    shortDesc: 'Get 3 emojis, draw the story',
    description: 'Get a random set of 3 emojis and draw a scene that includes all of them. A rocket, a cat, and a pizza? Draw a cat delivering pizza in space. The weirder, the better.',
    howToPlay: [
      'Tap to get your random emoji combo',
      'Draw a scene that includes ALL of them',
      'The drawing has to tell a story — get creative!',
      'Share and see how everyone else interpreted the same emojis',
    ],
    emojiSets: [
      ['🚀', '🐱', '🍕'],
      ['🏰', '🦖', '🎸'],
      ['🌊', '🤖', '🎂'],
      ['🌈', '🐧', '🏠'],
      ['🎪', '👻', '🍦'],
      ['🏔️', '🦋', '📚'],
      ['🌮', '🦄', '🎨'],
      ['🏖️', '🐙', '🎤'],
      ['🌙', '🐕', '🎈'],
      ['🏗️', '🦊', '🎻'],
    ],
    tip: "There's no wrong answer. A rocket-cat-pizza scene is just as valid as a space-delivery-service scene. If you're stuck, tell Ross your three emojis and ask for ideas!",
    minPlayers: 1,
    hasRounds: false,
    category: 'creative',
  },
  {
    id: 'portrait-swap',
    name: 'Portrait Swap',
    emoji: '🖼️',
    tagline: 'Draw each other!',
    shortDesc: 'Everyone draws someone else in the circle',
    description: 'Each person draws a portrait of someone else in the circle. It can be realistic, silly, superhero-style, or as a cartoon animal. The only rule: make them smile.',
    howToPlay: [
      'Each person picks someone in the circle to draw',
      'Draw their portrait — any style goes (silly, fancy, superhero, etc.)',
      'Share and guess who drew who!',
    ],
    tip: "Draw them as they want to be seen, or as a ridiculous superhero. Both are perfect. You can ask Ross to help you with the style — try 'draw a cartoon version of someone with curly hair wearing a cape.'",
    minPlayers: 2,
    hasRounds: false,
    category: 'creative',
  },
];

export const SKETCH_GUESS_PROMPTS = [
  'a cat riding a bicycle', 'a tree house', 'a robot cooking breakfast',
  'a penguin on a surfboard', 'a dragon flying a kite', 'a pizza party',
  'a spaceship landing', 'an elephant in a bathtub', 'a rainbow bridge',
  'a pirate ship', 'a unicorn in sunglasses', 'a snowman at the beach',
  'a dog driving a car', 'a monster under the bed', 'a castle in the clouds',
  'a birthday cake bigger than a house', 'a chicken in space',
  'a family of bears having a picnic', 'a fish riding a skateboard',
  'a superhero grandma', 'a wizard making pancakes',
  'a dinosaur playing basketball', 'an octopus juggling',
  'a haunted donut shop', 'a baby riding a dinosaur',
  'a flying ice cream truck', 'a giraffe in a swimming pool',
  'a ninja at the grocery store', 'a volcano made of chocolate',
  'a bunny piloting an airplane',
];
